import React, { useContext, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { PersonFill } from "react-bootstrap-icons";
import { TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ApiAuth from "../../../core/api/api.auth";
import ContextApp from "../../../core/contexts/context.app";
import ServiceStorage from "../../../core/services/service.storage";
import ServiceApi from "../../../core/services/service.api";
import SwalMessage from "../_Components/SwalMessage";
import VerifyMobile from "./Components/VerifyMobile";
import { PatternFormat } from "react-number-format";
import ApiSupplier from "../../../core/api/api.supplier";

const Login = () => {
  const navigate = useNavigate();
  const [loadingBtnLogin, setLoadingBtnLogin] = useState(false);
  const [loadingBtnLoginWithMobile, setLoadingBtnLoginWithMobile] =
    useState(false);
  const ctx = useContext(ContextApp);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: { id: 0 } });

  const [stateVerificationForm, setStateVerificationForm] = useState({
    show: false,
    mobile: "",
  });

  const [loginWithSMS, setLoginWithSMS] = useState(false);

  const handleLogin = async (data) => {
    if (!data.loginWithSMS && !data.password) {
      SwalMessage({
        title: "لطفا رمز عبور را وارد نمایید.",
        iSsuccess: false,
      });
      return;
    }
    try {
      if (data.loginWithSMS) {
        setLoadingBtnLoginWithMobile(true);
        const response = await ApiAuth.loginByMobile({
          phoneNumber: data.phoneNumber,
        });
        if (response.succeeded) {
          setStateVerificationForm({ show: true, mobile: data.phoneNumber });
          SwalMessage({
            title: response.message,
            iSsuccess: response.succeeded,
          });
        } else {
          SwalMessage({
            title: response.message,
            iSsuccess: response.succeeded,
          });
        }
      } else {
        setLoadingBtnLogin(true);
        const response = await ApiAuth.login({
          userName: data.phoneNumber,
          password: data.password,
        });
        if (response.succeeded) {
          ServiceStorage.setToken(
            response.data.jwToken,
            response.data.refreshToken
          );
          ServiceApi.setToken();
          ctx.setIsAuth(true);
          const supplierProfile = await ApiSupplier.getSupplierById(
            response.data.id
          );
          if (supplierProfile.data.supplierId === 0) {
            navigate("/supplierProfile");
          }
        } else {
          SwalMessage({
            title: response.message,
            iSsuccess: response.succeeded,
          });
        }
      }
    } catch (error) {
    } finally {
      setLoadingBtnLogin(false);
      setLoadingBtnLoginWithMobile(false);
    }
  };

  return (
    <div
      className="w-100 h-100 pb-5"
      style={{ backgroundColor: isMobile ? "#ffffff" : "#eef0f8" }}
    >
      {stateVerificationForm.show ? (
        <VerifyMobile mobileLogin={stateVerificationForm.mobile} />
      ) : (
        <>
          {isMobile ? (
            <MobileLoginForm
              handleSubmit={handleSubmit}
              control={control}
              errors={errors}
              loginWithSMS={loginWithSMS}
              setLoginWithSMS={setLoginWithSMS}
              loadingBtnLogin={loadingBtnLogin}
              loadingBtnLoginWithMobile={loadingBtnLoginWithMobile}
              handleLogin={handleLogin}
            />
          ) : (
            <DesktopLoginForm
              handleSubmit={handleSubmit}
              control={control}
              errors={errors}
              loginWithSMS={loginWithSMS}
              setLoginWithSMS={setLoginWithSMS}
              loadingBtnLogin={loadingBtnLogin}
              loadingBtnLoginWithMobile={loadingBtnLoginWithMobile}
              handleLogin={handleLogin}
            />
          )}
        </>
      )}
    </div>
  );
};

const MobileLoginForm = ({
  handleSubmit,
  control,
  errors,
  loginWithSMS,
  setLoginWithSMS,
  handleLogin,
  loadingBtnLogin,
  loadingBtnLoginWithMobile,
}) => (
  <div className="text-center">
    <img
      style={{ height: "200px" }}
      src="/media/bg/Traveling-rafiki-withouttext.png"
      alt="Traveling"
    />
    <h1 className="mt-0" style={{ color: "#407bff" }}>
      تفریحان
    </h1>
    <p className="text-muted">سامانه رزرو تفریحات کیش با تخفیف</p>
    <div className="mx-5" style={{ marginTop: "4rem" }}>
      <div
        className="pb-5 px-5 shadow-sm rounded-4"
        style={{ backgroundColor: "#eff2f3" }}
      >
        <div
          className="mx-auto"
          style={{
            backgroundColor: "rgb(239,242,243)",
            borderRadius: "50%",
            height: "60px",
            width: "60px",
            position: "relative",
            top: "-20px",
            bottom: "0px",
          }}
        >
          <PersonFill className="mx-auto my-2" color="#3699ff" size={48} />
        </div>
        <h5 className="text-center" style={{ color: "#91919b" }}>
          ورود به پنل <span style={{ color: "#3699ff" }}>تامین کنندگان</span>
        </h5>
        <LoginForm
          handleSubmit={handleSubmit}
          control={control}
          errors={errors}
          loginWithSMS={loginWithSMS}
          setLoginWithSMS={setLoginWithSMS}
          handleLogin={handleLogin}
          loadingBtnLogin={loadingBtnLogin}
          loadingBtnLoginWithMobile={loadingBtnLoginWithMobile}
        />
      </div>
    </div>
  </div>
);

const DesktopLoginForm = ({
  handleSubmit,
  control,
  errors,
  loginWithSMS,
  setLoginWithSMS,
  handleLogin,
  loadingBtnLogin,
  loadingBtnLoginWithMobile,
}) => (
  <div className="d-flex">
    <Col
      lg="4"
      className="p-5 my-auto"
      style={{ marginTop: "6rem", marginRight: "5rem" }}
    >
      <div
        className="m-5 pb-5 shadow-sm px-5 rounded-4"
        style={{ backgroundColor: "#fafbff" }}
      >
        <div
          className="mx-auto"
          style={{
            backgroundColor: "rgb(250,251,255)",
            borderRadius: "50%",
            height: "80px",
            width: "80px",
            position: "relative",
            top: "-30px",
            bottom: "0px",
          }}
        >
          <PersonFill className="mx-auto my-2" color="#3699ff" size={60} />
        </div>
        <h5 className="text-center" style={{ color: "#91919b" }}>
          ورود به پنل <span style={{ color: "#3699ff" }}>تامین کنندگان</span>
        </h5>
        <LoginForm
          handleSubmit={handleSubmit}
          control={control}
          errors={errors}
          loginWithSMS={loginWithSMS}
          setLoginWithSMS={setLoginWithSMS}
          handleLogin={handleLogin}
          loadingBtnLogin={loadingBtnLogin}
          loadingBtnLoginWithMobile={loadingBtnLoginWithMobile}
        />
      </div>
    </Col>
    <Col>
      <img
        style={{ width: "90%", height: "90%", float: "left" }}
        src="/media/bg/Traveling-rafiki.png"
        alt="Traveling"
      />
    </Col>
  </div>
);

const LoginForm = ({
  handleSubmit,
  control,
  errors,
  loginWithSMS,
  setLoginWithSMS,
  handleLogin,
  loadingBtnLogin,
  loadingBtnLoginWithMobile,
}) => {
  return (
    <form onSubmit={handleSubmit(handleLogin)}>
      <Controller
        name="phoneNumber"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <PatternFormat
            customInput={TextField}
            variant="standard"
            className="w-100 my-2"
            label="شماره موبایل"
            size="small"
            value={field.value || ""}
            dir="ltr"
            format="#### ### ####"
            onValueChange={(value) => field.onChange(value.value)}
          />
        )}
      />
      <Controller
        name="password"
        control={control}
        //rules={{ required: true }}
        render={({ field }) => (
          <TextField
            label="رمز عبور"
            type="password"
            className="w-100 my-2 ltr"
            variant="standard"
            size="small"
            value={field.value || ""}
            onChange={field.onChange}
          />
        )}
      />
      {errors.phoneNumber && (
        <small className="text-danger d-block">
          جهت ورود موبایل خود را وارد نمایید
        </small>
      )}
      {/* {errors.password && (
        <small className="text-danger d-block">لطفا رمز عبور را وارد نمایید!</small>
      )} */}
      <Row className="text-center my-5 gx-2">
        <Col xs="12" sm="6" className="mb-2">
          <Button
            className="w-100"
            variant="primary"
            type="submit"
            disabled={loadingBtnLogin}
          >
            {loadingBtnLogin ? <Spinner size="sm" /> : "ورود"}
          </Button>
        </Col>
        <Col xs="12" sm="6">
          <Button
            className="w-100"
            variant="outline-primary"
            type="button"
            disabled={loadingBtnLoginWithMobile}
            onClick={() => {
              handleSubmit((data) =>
                handleLogin({ ...data, loginWithSMS: true })
              )();
            }}
          >
            {loadingBtnLoginWithMobile ? (
              <Spinner size="sm" />
            ) : (
              "ورود با رمز یکبار مصرف"
            )}
          </Button>
        </Col>
      </Row>
      <div className="text-center">
        <Link
          to="/register"
          className="text-gray "
          style={{ fontSize: "12px" }}
        >
          حساب کاربری ندارید؟
          <strong className="text-primary mx-1" style={{ fontSize: "14px" }}>
            ثبت نام کنید
          </strong>
        </Link>
        <Link to="/forgotPassword">
          <p style={{ fontSize: "12px" }} className="text-gray mt-2 mb-5">
            در صورت{" "}
            <strong className="mx-1 text-primary"> فراموشی رمز عبور </strong>{" "}
            کلیک نمایید
          </p>
        </Link>
      </div>
    </form>
  );
};

export default Login;
